"use client";

import { useState } from "react";

type Props = {
    min?: number;
    max?: number;
    defaultValue?: number;
    onChange?: (qty: number) => void;
};

export default function QuantitySelector({ min = 1, max = 999, defaultValue = 1, onChange, }: Props) {

    const [qty, setQty] = useState(defaultValue);

    const update = (val: number) => {
        const clamped = Math.min(Math.max(val, min), max);
        setQty(clamped);
        onChange?.(clamped);
    };

    return (
        <div className="flex items-center border border-gray-400 w-40 overflow-hidden">
            <button
                onClick={() => update(qty - 1)}
                disabled={qty <= min}
                className="w-12 h-12 flex items-center justify-center text-white bg-gray-800 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            >
                −
            </button>

            <input
                type="number"
                value={qty}
                min={min}
                max={max}
                onChange={(e) => update(Number(e.target.value))}
                className="w-18 h-12 text-center text-sm font-medium text-blackColor border-x border-gray-400 focus:outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            />

            <button
                onClick={() => update(qty + 1)}
                disabled={qty >= max}
                className="w-12 h-12 flex items-center justify-center text-white bg-gray-800 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            >
                +
            </button>
        </div>
    );
}